import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageSERIEA3 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Elisabetta Vignotto: The Italian Pioneer",
            author: "footballgirl",
          date: "March 5, 2026",
      image: "images/seriea/3a.jpg",
        content: `<p><h3>Elisabetta Vignotto:</h3> The Prolific Pioneer
Born in 1954, Elisabetta Vignotto emerged as a
 beacon in the nascent world of Italian women's 
 football, her goal-scoring prowess becoming 
 synonymous with the sport's early growth.</p>
 
 <p>She kicked off her senior career in 1970 
 with Gommagomma (later ACF Milan), 
where she netted 18 goals in 22 matches,
 clinching the Serie A title and making 
 her debut for the Azzurre, scoring against Denmark. 
 This marked the beginning of a nomadic yet
  triumphant club journey, driven by her 
  unyielding hunger for success.</p>

  <h3>1971</h3>
 <p>By 1971, Vignotto had switched to Real 
Juventus, unleashing an extraordinary 
51 goals in just 22 games to
 secure another Serie A 
 crown and top the scoring charts.</p>
 
 <p>Her international exploits shone during the 
 1971 Women's World Cup qualifiers
  and the tournament in Mexico, where Italy 
  reached the final. </p>

   <h3> Gamma 3 Padova</h3>
  <p>The following years 
  saw her dominate with Gamma 3 Padova from 
  1972 to 1975, amassing 108 goals in 78 appearances,
   winning back-to-back Serie A titles 
   in 1972 and 1973, the Coppa Italia in 1974,
    and leading the goal tallies in those 
    championship seasons.</p>
    
    <p>Key international 
    moments included strikes against Spain 
    and Czechoslovakia, solidifying her as
     a national hero.</p>
     
    <h3> the late 1970s and 1980s</h3>
     <p>
Vignotto's career continued its relentless 
pace through the late 1970s and 1980s. 
Stints with Valdobbiadene in 1976 (27 goals,
 another Serie A win), Padova in 1977 (35 goals),
  and Eurokalor Bologna in 1978 (13 goals)
   were highlighted by contributions to the
    1978 Mundialito.</p>
    
    <p>With Gorgonzola from 1979 
    to 1982, she scored 91 goals in 82 games, 
    lifting the Coppa Italia in 1980 and 
    topping Serie A goals that year.</p>
    
   <p> Brief spells at Piacenza, Giolli 
   Gelati Roma, and Roma CF added more
    accolades, before she excelled with 
    Friulvini Pordenone (1986–1988, 36 goals)
     and helped Italy triumph in the 
     1986 Mundialito.</p>

  <h3>Her final chapter</h3>
     <p> Her final chapter
      with Reggiana Zambelli
       (1988–1990) brought
        a Serie A title in 1989–90.
        </p> <p>
Internationally, from 1970 to 1989, 
Vignotto donned the Azzurre jersey 110 times,
 scoring a staggering 107 goals—a women's
  international record until 1999. </p>
  
  <h3>Retiring</h3>
  <p>After retiring, she transitioned into
   leadership roles, chairing clubs like 
   A.S.D. Reggiana Calcio Femminile and 
   A.S.D. Sassuolo Calcio Femminile.</p>
   
  <h3> Hall of Fame </h3>
  <p> Her induction into the Italian Football 
   Hall of Fame in 2017 cemented her status 
   as a foundational legend.</p>`,
            tags: [ " Elisabetta Vignotto",  "Italy", "World Cup qualifier" ],
        navIndices: { prev: 'seriea-2', next: 'seriea-4' }
        });
    }

    init() {
        console.log('ArticlePageSERIEA3 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to Serie A
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'seriea' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_seriea.png';
            leagueLogo.alt = 'Serie A';
        }
    }
}